module.exports = __webpack_public_path__ + "b485bd355587a0eccf7f78eaea509bfa.svg";